<template>
  <div
    :class="['initials-field', { required: isRequired, 'show-pointer': !disabled }]"
    @click="handleClick"
  >
    {{ text }}
  </div>
</template>
<script lang="ts">
import { initialHelper } from '@getaccept/lib-shared-new/src/helpers';
import { useI18n } from 'vue-i18n';
import { defineComponent, computed } from 'vue';

export default defineComponent({
  props: {
    initials: {
      type: String,
      default: '',
    },
    verifiedInitials: {
      type: String,
      default: '',
    },
    fullName: {
      type: String,
      default: '',
    },
    completed: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
  },
  emits: ['click'],
  setup(props, { emit }) {
    const { t } = useI18n();
    const text = computed(() => {
      if (props.verifiedInitials) {
        return props.verifiedInitials;
      }
      if (props.completed) {
        return props.initials;
      }
      if (props.disabled) {
        return initialHelper(props.fullName);
      }
      return t('initials-abbreviation');
    });

    const isRequired = computed(() => !props.disabled && !props.completed);

    const handleClick = () => {
      emit('click');
    };

    return {
      text,
      isRequired,
      handleClick,
    };
  },
});
</script>
<style lang="scss" scoped>
.initials-field {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;

  &.required {
    color: var(--text-gray);

    &::after {
      color: var(--error-dark);
      content: '*';
    }
  }

  &.show-pointer {
    cursor: pointer;
  }
}
</style>
